import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const CubeLoader = ({ variant = 'route', label }) => {
  const size = variant === 'inline' ? 'compact' : 'full';
  const [gifSrc, setGifSrc] = useState('/img/logo-cube-2.gif');
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    // Cache-buster: some browsers show a static first frame on re-mount.
    setGifSrc(`/img/logo-cube-2.gif?ts=${Date.now()}`);
  }, []);

  useEffect(() => {
    const mq = typeof window !== 'undefined' ? window.matchMedia?.('(prefers-reduced-motion: reduce)') : null;
    if (!mq) return;

    const apply = () => setReducedMotion(!!mq.matches);
    apply();

    // Safari < 14 fallback
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', apply);
      return () => mq.removeEventListener('change', apply);
    }
    mq.addListener?.(apply);
    return () => mq.removeListener?.(apply);
  }, []);

  const faces = useMemo(
    () => (
      <>
        <div className="cube-loader__face cube-loader__face--1" />
        <div className="cube-loader__face cube-loader__face--2" />
        <div className="cube-loader__face cube-loader__face--3" />
        <div className="cube-loader__face cube-loader__face--4" />
        <div className="cube-loader__face cube-loader__face--5" />
        <div className="cube-loader__face cube-loader__face--6" />
      </>
    ),
    []
  );

  return (
    <div className={`cube-loader cube-loader--${size}`} role="status" aria-live="polite" aria-busy="true">
      <div className="cube-loader__stage">
        {reducedMotion ? (
          <div className="cube-loader__box">{faces}</div>
        ) : (
          <img src={gifSrc} alt="Loading" />
        )}
      </div>
      {label ? <div className="cube-loader__label">{label}</div> : null}
    </div>
  );
};

CubeLoader.propTypes = {
  variant: PropTypes.oneOf(['route', 'inline']),
  label: PropTypes.node,
};

export default CubeLoader;
